import { get } from 'lodash-es';
import { getPayload } from 'modules/api';

export const getLinksPayload = (response) => {
  const payload = getPayload(response);
  return get(payload, 'links');
};
